import { twJoin } from "tailwind-merge"
import Link from "next/link"
import React from "react"
import Image from "next/image"
import { data } from "./data"
import Logo from "@components/UI/Logo"
import australianHeart from "@images/australianHeart.png"
import css from "@utils/css"
import linkedin from "@images/linkedin.svg"
import { MainButton } from "@components/MainButton/MainButton"
import useUtmTags, {Utm} from "@hooks/useUtmTags";
import FooterDataRequestLink from "@components/Footer/FooterDataRequestLink";

const LinksColl = ({ column, className }: { className?: string; column: (typeof data)[number] }) => (
  <div
    key={column.columnKey}
    className={twJoin("flex flex-col gap-48p w-full", className)}
  >
    {column.items.map((item, i) => (
      <div
        key={item.title}
        className="flex flex-col gap-16p"
      >
        <Link
            className={twJoin("text-16p font-600 leading-24p text-white", "hover:text-neutral2-400")}
            href={item.href}
            key={i}
        >
          {item.title}
        </Link>
        {item.subItems.map((subData) => (
          <Link
            key={subData.title}
            href={subData.href}
            className={twJoin("text-14p font-400 leading-20p text-neutral2-300", "hover:text-neutral2-400")}
          >
            {subData.title}
          </Link>
        ))}
      </div>
    ))}
  </div>
)

export const FooterV2 = () => {
  const [column1, column2, column3] = data

  return (
    <footer className={twJoin(
      "bg-gray-blue-900",
      "[&:is(.help-center+footer)]:mt-12",
      "[&:is(.container+footer)]:mt-20"
    )}>
      <div
        className={twJoin(
          "flex flex-col mx-auto",
          "gap-32p",
          "pb-32p",
          "px-20p",
          "pt-32p",
          "768:pt-32p",
          "768:px-32p",
          "1024:gap-32p",
          "1024:pb-32p",
          "1024:pt-80p",
          "1024:px-32p",
          "1024:max-w-screen-1440",
          "1440:gap-40p",
          "1440:pt-80p",
          "1440:pb-40p",
          "1440:px-160p"
        )}
      >
        <div
          className={twJoin(
            "grid",
            "gap-32p",
            "768:gap-10p",
            "1024:gap-32p",
            "1440:gap-48p",
            "grid-cols-1",
            "480:grid-cols-2",
            "768:grid-cols-3",
            "1024:grid-cols-4"
          )}
        >
          <LinksColl
            column={column1}
            className={"order-2 768:order-[unset]"}
          />

          <div className={twJoin("flex flex-col order-3 768:order-[unset] 1024:flex-row gap-48p 1024:col-span-2")}>
            <LinksColl column={column2} />
            <LinksColl column={column3} />
          </div>

          <div
            className={twJoin(
              "flex flex-col flex-wrap gap-24p",
              "order-1 col-span-1",
              "480:col-span-2",
              "768:col-span-1",
              "768:order-[unset]"
            )}
          >
            <Link
              href="/"
              className="mb-6"
            >
              <Logo
                width={48}
                className={""}
              />
            </Link>
            <h3 className="text-20p font-600 leading-32p text-white">Ready to get started?</h3>
            <div className="flex flex-col gap-16p">
              <MainButton
                size={44}
                size1024={48}
                href={ useUtmTags(
                    `${ process.env.NEXT_PUBLIC_APP_TRAQQ_URL }/signup`,
                    {utm_medium: Utm.MEDIUM.FOOTER, utm_campaign: Utm.CAMPAIGN.BUTTON, utm_term: "Try it completely free"}
                    )}
              >
                Try it completely free
              </MainButton>
              {/*<MainButton
                size={44}
                size1024={48}
                theme={"tertiary"}
                href={useUtmTags(
                    "/demo",
                    { utm_medium: Utm.MEDIUM.FOOTER, utm_campaign: Utm.CAMPAIGN.LINK, utm_term: "Book a demo"}
                    )}
              >
                Book a demo
              </MainButton>*/}
            </div>
            <div className="flex flex-col gap-y-0.5 mb-4">
              <span>
                <strong className={twJoin("text-16p font-600 leading-24p text-white")}>
                  Designed in Sydney,
                  <br />
                  Australia
                </strong>
                &nbsp;
                <Image
                  src={australianHeart}
                  alt="Traqq Australia"
                  width={48}
                  height={49}
                  className="inline w-[24px] h-auto"
                  loading="lazy"
                  priority={false}
                  unoptimized
                />
              </span>
              <p className={twJoin("text-12p font-400 leading-20p text-neutral2-300")}>
                Level 10, 88 Phillip Street, Sydney NSW 2000. Traqq Pty Ltd.
              </p>
            </div>
          </div>
        </div>
        {/* <div className={twJoin("flex flex-row gap-16p flex-wrap justify-center 1024:justify-start")}>
          {[
            {
              src: capterraShortlist,
              alt: "Capterra short list",
              href: "https://www.capterra.com/employee-monitoring-software/shortlist",
            },
            {
              src: crozdeskQualityChoice,
              alt: "Crozdesk quality choice",
              href: "https://crozdesk.com/software/traqq",
            },
            {
              src: g2UsersLoveUs,
              alt: "g2 users love us",
              href: "https://www.g2.com/products/traqq/reviews?utm_source=rewards-badge",
            },
            {
              src: getApp,
              alt: "Get App",
              href: "https://www.getapp.com/project-management-planning-software/a/traqq",
            },
            {
              src: slashdotUsersLoveUs,
              alt: "Slashdot users love us",
              href: "https://slashdot.org/software/p/Traqq",
            },
            {
              src: softwareAdvice,
              alt: "Software advice",
              href: "https://www.softwareadvice.com/project-management/time-tracking-comparison/#frontrunners",
            },
            {
              src: topBusinessHighAchiever,
              alt: "Top business high achiever",
              href: "https://topbusinesssoftware.com/products/Traqq/reviews",
            },
          ].map(({ src, alt, href }, i) => (
            <a
              key={i}
              href={href}
              className={"flex justify-center max-768:basis-[150px]"}
            >
              <Image
                className="h-[120px] w-auto"
                alt={alt}
                src={src}
                height={120}
                priority={false}
              />
            </a>
          ))}
        </div> */}
      </div>
      <div className={"border-t border-gray-blue-700"} />
      <div
        className={twJoin(
          "mx-auto",
          "768:flex-row",
          "flex flex-col justify-between",
          "gap-10p",
          "py-8p",
          "text-12p leading-20p text-neutral2-200",
          "px-20p",
          "1024:max-w-screen-1440",
          "768:px-32p",
          "1024:px-32p",
          "1440:px-160p"
        )}
      >
        <div className={css("flex flex-wrap gap-8p")}>
          Copyright 2019 - {new Date().getFullYear()} Traqq. All rights reserved.
          <Link
            href="https://www.linkedin.com/company/traqq-time-tracking"
            target="_blank"
            className="flex items-center hover:text-neutral2-300"
          >
            <Image
              src={linkedin}
              alt="Follow us on LinkedIn"
              width={16}
              height={17}
              priority={false}
            />
            &nbsp;
            <span>LinkedIn</span>
          </Link>
        </div>
        <div className={twJoin("flex gap-8p")}>
          <Link
              href="/legal/cookies"
              className="!leading-5 hover:text-neutral2-300"
          >
            Cookie policy
          </Link>
          <span className="divider divider_solid divider_vertical" />
          <Link
            href="/legal/privacy"
            className="!leading-5 hover:text-neutral2-300"
          >
            Privacy policy
          </Link>
          <span className="divider divider_solid divider_vertical" />
          <Link
            href="/legal/terms"
            className="!leading-5 hover:text-neutral2-300"
          >
            Terms of use
          </Link>
          <span className="divider divider_solid divider_vertical" />
          <Link
            href="/legal/terms#fees-and-refunds"
            className="!leading-5 hover:text-neutral2-300"
          >
            Refund policy
          </Link>
          <FooterDataRequestLink />
        </div>
      </div>
    </footer>
  )
}
